/**
 * ! @description : Origin Component for Group Table
 */

// Dependency
import React from "react";

// CSS
import "../../../../css/grouptable.css";
import "../../../../css/Settings.css";

// Component
import GroupTable from "./GroupTable";

function Settings() {
  return (
    <div>
      <GroupTable />
    </div>
  );
}

export default Settings;
